import { Routes } from '@angular/router';
import { AppRoleGuardService } from '@app/auth/app-role-guard.service';
import { ItemsIndexComponent } from "@app/cem/project/items/items-index/items-index.component";
import { ScopingItemsIndexComponent } from "@app/cem/project/scoping-items/scoping-items-index/scoping-items-index.component";
import { StdCfgIndexComponent } from "@app/cem/project/standard-config/std-cfg-index/std-cfg-index.component";
import { WellsComponent } from "@app/cem/project/wells/wells.component";
import { ProjectTeamHomeComponent } from '../core-data/project-team-home/project-team-home.component';
import { ProjectEstimateHomeComponent } from './estimate/project-estimate-home/project-estimate-home.component';
import { FormationTopComponent } from './formation-top/formation-top.component';
import { LayoutComponent } from './landing/layout/layout.component';
import { AuthConstants } from '@app/common/constants/AuthConstants';

let roles = AuthConstants.ROLES;

export const ProjectRoutes: Routes = [
  {
    path: 'home', component: LayoutComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Home',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name
      ]
    }
  },
  {
    path: 'estimate',
    component: ProjectEstimateHomeComponent,
    data: {
      title: 'Estimate',
    }
  },
  {
    path: 'project-teams',
    component: ProjectTeamHomeComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Project Team',
      expectedRoles: ["BLOCKED"] // TODO: Remove route and components, not used anymore
    }
  },
  {
    path: 'formation-top',
    component: FormationTopComponent,
    data: {
      title: 'Formation Tops',
    }
  },
  {
    path: 'items', component: ItemsIndexComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Items',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name
      ]
    }
  },
  {
    path: 'scoping-items', component: ScopingItemsIndexComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Scoping Items',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name
      ]
    }
  },
  {
    path: 'standard-configs', component: StdCfgIndexComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Standard Configs',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name
      ]
    }
  },
  {
    path: 'wells',
    component: WellsComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Wells',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name
      ]
    }
  }
];